import React from "react";

const FullWidthButton = ({ onClick, children, height = "auto", className = "btn-primary", plusClass = "", disabled = false, fontSize = "1rem", style = {}, type = "button" }) => {
	return (
		<button
			type={type}
			className={`btn btn-lg w-100 ${className} ${plusClass}`}
			onClick={onClick}
			disabled={disabled}
			style={{
				height,
				fontSize,
				...style,
			}}
		>
			{children}
		</button>
	);
};

export default FullWidthButton;
